import { useMutation } from '@tanstack/react-query';

import { startGoogleWalletSigning } from '@domain/digital-wallet';
import { Card } from '@generated-types';

const GOOGLE_WALLET_SIGNING = 'GOOGLE_WALLET_SIGNING';

export const useGoogleWalletSigningMutation = ({ card }: { card: Card }) =>
    useMutation({
        mutationKey: [GOOGLE_WALLET_SIGNING, card],
        mutationFn: () => startGoogleWalletSigning(card),
    });
